import { Injectable, inject } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { Observable, lastValueFrom, of } from 'rxjs';
import { AuthServiceCommon } from '../common';
import { AuthServiceBase } from '../base';
import { protectedResources } from '../../configs/auth.config';

@Injectable({
    providedIn: 'root',
})
export class BrowserAuthService
    extends AuthServiceCommon
    implements AuthServiceBase
{
    msalGuardConfiguration = inject(
        MSAL_GUARD_CONFIG
    ) as unknown as MsalGuardConfiguration;

    init(): void {}
    getAuthToken(): string | undefined {
        return undefined;
    }
    override login(): Promise<void> {
        return lastValueFrom(
            this.msalService.loginRedirect({
                scopes: [
                    protectedResources.cruiseCodeWebApi.scopes.read[0],
                    protectedResources.cruiseCodeWebApi.scopes.write[0],
                ],
            })
        ).then(() => {
            this.checkAndSetActiveAccount();
            return Promise.resolve();
        });
    }

    override logout(): Promise<void> {
        return lastValueFrom(this.msalService.logout()).then(() => {
            this.checkAndSetActiveAccount();
            return Promise.resolve();
        });
    }
}
